import React from 'react';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components';
import cx from 'classnames';

export interface AssetContactProps {
  name: string;
  onClick?: () => void;
}

export default function AssetContact({ name, onClick }: AssetContactProps) {
  const hasOnClickCallback = onClick !== undefined;
  return (
    <Button
      variant={ButtonVariant.Icon}
      className={cx(
        'flex items-center gap-x-1.5 text-neutral-400 !p-0 max-w-[60%]',
        {
          'group hover:text-turquoise': hasOnClickCallback,
          'hover:text-neutral-400 cursor-auto': !hasOnClickCallback,
        }
      )}
      onClick={onClick}
    >
      <i
        className={cx('icon icon-sm icon-contact !bg-neutral-600', {
          'group-hover:!bg-turquoise': hasOnClickCallback,
        })}
      />{' '}
      <span className='flex-1 truncate'>{name}</span>
    </Button>
  );
}
